<template>
    <div class="equipDatabaseModalContainer">
        <b-modal
            ref="databaseModal"
            centered
            @hidden="closeDataModal"
            size="xl"
            hide-footer
            title="데이터"
            id="equipDatabaseModal"
        >
            <!-- 상단 탭 -->
            <div class="table-header-bar">
                <div class="tab-wrapper">
                    <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">위치별</div>
                    <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">요소별</div>
                </div>
            </div>

            <!-- 스켈레톤 테이블 -->
            <div v-if="loading" class=" scrollable-table skeleton-table">
                <div class="skeleton skeleton-cell skeleton-header-text"></div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th v-for="n in 9" :key="`header-skel-${n}`">
                                <div class=" skeleton-header"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="n in 20" :key="`body-skel-row-${n}`">
                            <td v-for="m in 9" :key="`body-skel-${n}-${m}`">
                                <div class="skeleton skeleton-cell"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 위치별 테이블 -->
            <div v-if="!loading && activeTab === 0 && selectedLocationKey" class="tables-by-location">
                <div class="mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5>{{ getLocationTitle(selectedLocationKey) }}</h5>
                        <div class="d-flex align-items-center">
                            <b-form-select
                                v-model="selectedLocationKey"
                                :options="locationSelectOptions"
                                class="w-auto mr-2"
                                size="sm"
                            />
                            <b-button size="sm" variant="outline-primary" @click="exportToExcel('location')">
                                엑셀 다운로드
                            </b-button>
                        </div>
                    </div>

                    <!-- 실제 데이터 테이블 (로딩 아닐 때만) -->
                    <div class="scrollable-table">
                        <table class="table table-bordered text-center">
                            <thead class="thead-dark">
                                <tr>
                                    <th class="align-middle">시간</th>
                                    <th
                                        v-for="(header, i) in groupTrend[selectedLocationKey].headers"
                                        :key="`${header.ptIdx}-${i}`"
                                        class="align-middle"
                                    >
                                        {{ header.dispText }}<br />({{ transUnit(header.unitSmallCode) }})
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in groupTrend[selectedLocationKey].results" :key="row.regDt">
                                    <td class="align-middle">{{ replaceTwithSpace(row.regDt) }}</td>
                                    <td
                                        v-for="(header, i) in groupTrend[selectedLocationKey].headers"
                                        :key="`${header.ptIdx}-${i}`"
                                        class="align-middle"
                                    >
                                        {{ formatValue(row[header.ptIdx]) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- 요소별 테이블 -->
            <div v-if="!loading && activeTab === 1 && selectedIndicatorCode" class="tables-by-indicator">
                <div class="mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5>요소별 데이터 - {{ getIndicatorName(selectedIndicatorCode) }}</h5>
                        <div class="d-flex align-items-center">
                            <b-form-select
                                v-model="selectedIndicatorCode"
                                :options="indicatorSelectOptions"
                                class="w-auto mr-2"
                                size="sm"
                            />
                            <b-button size="sm" variant="outline-primary" @click="exportToExcel('indicator')">
                                엑셀 다운로드
                            </b-button>
                        </div>
                    </div>

                    <!-- 실제 데이터 테이블 (로딩 아닐 때만) -->
                    <div class="scrollable-table">
                        <table class="table table-bordered text-center">
                            <thead class="thead-dark">
                                <tr>
                                    <th class="align-middle">시간</th>
                                    <th
                                        v-for="(col, i) in pivotedIndicatorData.columns"
                                        :key="`${col.label}-${i}`"
                                        class="align-middle"
                                    >
                                        {{ col.label }}<br />({{ col.unit }})
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in pivotedIndicatorData.tableRows" :key="row.regDt">
                                    <td class="align-middle">{{ replaceTwithSpace(row.regDt) }}</td>
                                    <td
                                        v-for="(col, i) in pivotedIndicatorData.columns"
                                        :key="`${col.label}-${i}`"
                                        class="align-middle"
                                    >
                                        {{ row[col.label] }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import backEndApi from "@src/api/backEndApi";
import { mapGetters } from "vuex";
import excelHelper from "@src/libs/excelHelper.js";

export default {
    props: ["flag", "statusDate", "currentNode", "baseChartData", "queryType"],
    data() {
        return {
            activeTab: 0,
            selectedLocationKey: null,
            selectedIndicatorCode: null,
            locationArr: null,
            indicatorArr: null,
            groupTrend: null,
            props: ["calcProps", "ioProps", "userProps"],
            loadingStatus: false,
            loadingTrend: false,
        };
    },
    mounted() {},
    computed: {
        ...mapGetters({
            units: "units",
            systemTypeList: "systemTypeList",
        }),
        loading() {
            return this.loadingStatus || this.loadingTrend;
        },
        filterSystemType() {
            return this.systemTypeList.find((type) => type.sysType === this.currentNode.sysType);
        },
        filteredLocationKeys() {
            if (!this.groupTrend) return [];
            return Object.keys(this.groupTrend).filter((key) => key !== "summary");
        },
        locationSelectOptions() {
            return this.filteredLocationKeys.map((key) => ({
                value: key,
                text: this.getLocationTitle(key),
            }));
        },
        indicatorSelectOptions() {
            return this.indicatorArr.map((ind) => ({
                value: ind.propCode,
                text: ind.propName,
            }));
        },
        regDtList() {
            const firstKey = Object.keys(this.groupTrend).find((key) => key !== "summary");
            if (!firstKey) return [];

            const results = this.groupTrend[firstKey]?.results || [];
            return results.map((r) => r.regDt);
        },
        pivotedIndicatorData() {
            if (!this.selectedIndicatorCode) {
                return { columns: [], tableRows: [] };
            }

            // const times = this.groupTrend.summary.results.map((r) => r.regDt);
            const columns = this.filteredLocationKeys
                .map((key) => {
                    const header = this.groupTrend[key]?.headers.find((h) => h.propCode === this.selectedIndicatorCode);
                    return {
                        key,
                        label: this.getLocationTitle(key),
                        ptIdx: header?.ptIdx || null,
                        unit: this.transUnit(header?.unitSmallCode) || "-",
                    };
                })
                .filter((col) => col.ptIdx);

            const tableRows = this.regDtList.map((regDt, rowIndex) => {
                const row = { regDt };
                columns.forEach((col) => {
                    row[col.label] = this.groupTrend[col.key]?.results?.[rowIndex]?.[col.ptIdx] ?? "-";
                });
                return row;
            });

            return { columns, tableRows };
        },
        // 현재 노드가 최상위 노드일경우와 그 하위 노드인지 판별하기 위함. 데이터 구조가 다름
        equipStatusList() {
            const { nodeType } = this.currentNode || {};

            if (nodeType === "System" || nodeType === "Root") {
                // equipStatus 객체 → 내부 equipStatus 배열들 전부 평탄화
                return Object.values(this.status?.equipStatus || {}).flatMap((group) => group.equipStatus || []);
            }

            if (nodeType === "Group") {
                // Group이면 바로 배열
                return this.status?.equipStatus || [];
            }

            if (nodeType === "Equip") {
                // 단일 장비 노드일 경우도 배열로 묶어서 반환
                return [this.status?.equipStatus].filter(Boolean);
            }

            return [];
        },
    },
    watch: {
        flag(newVal) {
            if (newVal) {
                this.showDataModal();
                this.getEquipStatus(this.currentNode, this.statusDate);
                this.getGroupTrendData(this.currentNode, this.statusDate);
            } else {
                this.closeDataModal();
            }
        },
    },
    methods: {
        formatValueData(rawData) {
            if (this.currentNode.nodeType === "System" || this.currentNode.nodeType === "Root") {
                const flat = {};
                let foundSummary = null;

                Object.values(rawData).forEach((systemGroup) => {
                    if (typeof systemGroup !== "object") return;

                    Object.entries(systemGroup).forEach(([equipIdx, equipData]) => {
                        if (equipIdx === "summary") {
                            foundSummary = equipData;
                        } else if (equipIdx !== "summary") {
                            flat[equipIdx] = equipData;
                        }

                        if (!foundSummary && equipData?.summary) {
                            foundSummary = equipData.summary;
                        }
                    });
                });

                if (foundSummary) {
                    flat.summary = foundSummary;
                }

                return flat;
            } else {
                return rawData;
            }
        },

        async exportToExcel(type) {
            try {
                let headers = [];
                let excelData = [];
                let fileName = "";
                let sheetName = "";

                if (type === "location" && this.selectedLocationKey) {
                    const locationHeaders = this.groupTrend[this.selectedLocationKey]?.headers || [];
                    const rows = this.groupTrend[this.selectedLocationKey]?.results || [];

                    // 헤더 정의
                    headers = [
                        "시간",
                        ...locationHeaders.map((h) => `${h.dispText} (${this.transUnit(h.unitSmallCode)})`),
                    ];

                    // 데이터 변환
                    excelData = rows.map((row) => {
                        const rowData = {
                            시간: this.replaceTwithSpace(row.regDt),
                        };

                        locationHeaders.forEach((header) => {
                            const headerKey = `${header.dispText} (${this.transUnit(header.unitSmallCode)})`;
                            rowData[headerKey] =
                                row[header.ptIdx] !== null && row[header.ptIdx] !== undefined ? row[header.ptIdx] : "-";
                        });

                        return rowData;
                    });

                    fileName = `위치별_데이터_${this.getLocationTitle(this.selectedLocationKey)}.xlsx`;
                    sheetName = `위치별_${this.getLocationTitle(this.selectedLocationKey)}`;
                } else if (type === "indicator" && this.selectedIndicatorCode) {
                    const indicatorHeaders = this.pivotedIndicatorData.columns || [];
                    const rows = this.pivotedIndicatorData.tableRows || [];

                    // 헤더 정의
                    headers = ["시간", ...indicatorHeaders.map((h) => `${h.label} (${h.unit})`)];

                    // 데이터 변환
                    excelData = rows.map((row) => {
                        const rowData = {
                            시간: this.replaceTwithSpace(row.regDt),
                        };

                        indicatorHeaders.forEach((header) => {
                            const headerKey = `${header.label} (${header.unit})`;
                            rowData[headerKey] =
                                row[header.label] !== null && row[header.label] !== undefined ? row[header.label] : "-";
                        });

                        return rowData;
                    });

                    fileName = `요소별_데이터_${this.getIndicatorName(this.selectedIndicatorCode)}.xlsx`;
                    sheetName = `요소별_${this.getIndicatorName(this.selectedIndicatorCode)}`;
                }

                if (!headers.length || !excelData.length) {
                    console.warn("Excel 내보내기 실패: 데이터가 유효하지 않음");
                    return;
                }

                // 컬럼 너비 설정
                const columnWidths = {
                    시간: 20,
                };
                headers.slice(1).forEach((header) => {
                    columnWidths[header] = 15;
                });

                // 셀 타입 설정
                const cellTypes = {
                    시간: "string",
                };
                headers.slice(1).forEach((header) => {
                    cellTypes[header] = "number";
                });

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName,
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths,
                    cellTypes,
                });

                console.log("Excel 다운로드 완료:", fileName);
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
            }
        },

        replaceTwithSpace(dateTimeStr) {
            return dateTimeStr.replace("T", " ");
        },
        transUnit(unitCode) {
            const found = this.units.find((u) => u.value === unitCode);
            return found ? found.text : "-";
        },
        showDataModal() {
            this.$refs.databaseModal?.show();
        },
        closeDataModal() {
            this.$refs.databaseModal?.hide();
            this.$emit("closeDataBaseModal");
        },
        formatValue(val) {
            return val === null || val === undefined ? "-" : val;
        },
        getLocationTitle(key) {
            const firstHeader = this.groupTrend[key]?.headers?.[0];
            if (firstHeader?.ptName) {
                const parts = firstHeader.ptName.split("/");
                return parts.length > 1 ? parts[1] : key;
            }
            return key;
        },
        getIndicatorName(code) {
            // return this.groupTrend.summary.headers.find((h) => h.propCode === code)?.propName || code;
            return this.indicatorArr.find((h) => h.propCode === code)?.propName || code;
        },
        async getEquipStatus(node, date) {
            this.loadingStatus = true;

            const statusParams = {
                sysNodeIdx: node.sysNodeIdx,
                queryDate: date || this.today,
                queryType: this.queryType || "NOW",
                maxDepth: 1,
                ignoreZero: "Y",
            };
            if (this.filterSystemType?.sumAvail === "Y") {
                statusParams.targetField = this.filterSystemType.sysType === "ENGSRC" ? "zoneIdx" : "engUseType";
            }

            try {
                const result =
                    node.nodeType === "Group"
                        ? await backEndApi.sysNode.getGroupOprtStatus(statusParams)
                        : node.nodeType === "System" || node.nodeType === "Root"
                        ? await backEndApi.sysNode.getSystemOprtStatus(statusParams)
                        : await backEndApi.sysNode.getEquipOprtStatus(statusParams);

                if (result.status === 200) {
                    this.status = result.data;
                    this.filterLocation();
                    this.filterIndicator();
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.loadingStatus = false;
            }
        },
        async getGroupTrendData(node, date) {
            this.loadingTrend = true;

            const statusParams = {
                sysNodeIdx: node.sysNodeIdx,
                queryType: this.queryType,
                queryDate: date || this.today,
            };
            try {
                const api =
                    node.nodeType === "Group"
                        ? backEndApi.sysNode.getGroupTrendData
                        : node.nodeType === "Equip"
                        ? backEndApi.sysNode.getEquipTrendData
                        : backEndApi.sysNode.getSystemTrendData;

                const result = await api(statusParams);

                if (result.status === 200) {
                    this.groupTrend = this.formatValueData(result.data);
                    // this.groupTrend = result.data;

                    const locationKeys = Object.keys(this.groupTrend).filter((k) => k !== "summary");
                    this.selectedLocationKey = locationKeys[0] || null;

                    // this.selectedIndicatorCode = this.groupTrend.summary?.headers?.[0]?.propCode || "-";
                    this.selectedIndicatorCode = this.indicatorArr[0].propCode || "-";
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.loadingTrend = false;
            }
        },
        filterLocation() {
            this.locationArr = this.equipStatusList?.map((s) => s.equipName) || [];
        },
        filterIndicator() {
            const unique = new Map();
            this.props.forEach((prop) => {
                this.equipStatusList?.forEach((state) => {
                    state[prop]?.forEach((d) => {
                        if (!unique.has(d.propCode)) unique.set(d.propCode, d.propName);
                    });
                });
            });
            this.indicatorArr = [...unique].map(([propCode, propName]) => ({ propCode, propName }));
        },
    },
};
</script>

<style scoped>
.table {
    width: 100%;
    border-collapse: collapse;
    table-layout: sticky;
    margin-top: 10px;
}

.table th,
.table td {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 8px;
    text-align: center;
    background-clip: padding-box;
}

.table th {
    font-size: 13px;
    position: sticky;
    top: 0;
    background-color: #343a40;
    color: #fff;
    z-index: 3;
}

.tab-wrapper {
    display: flex;
    gap: 16px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 6px;
}

.tab-item {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    border-bottom: 2px solid transparent;
    padding: 1rem;
}

.tab-item.active {
    color: #000;
    border-bottom: 2px solid #007bff;
}

.dataBody {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.scrollable-table {
    max-height: 70vh;
    overflow-y: auto;
}
.skeleton-table {
    height: 70vh;
}
.skeleton {
    display: inline-block;
    width: 100%;
    height: 30px;
    border-radius: 4px;
    background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite linear;
}

.skeleton-header {
    height: 20px;
}

.skeleton-table .table {
    margin-top: 10px;
}
.skeleton-header-text {
    width: 20%;
}
@keyframes skeleton-loading {
    from {
        background-position: 200% 0;
    }
    to {
        background-position: -200% 0;
    }
}
</style>
